import React from 'react';

export default function Footer() {
  return (
    <footer style={{textAlign: 'center', color: '#6ef8b5', padding: 30, marginTop: 40, opacity: 0.7}}>
      Neo Typer &copy; 2025. All rights reserved.
    </footer>
  );
}
